import { useEffect } from 'react';
import type { ToastMessage } from '../types';

interface Props {
  messages: ToastMessage[];
  onDismiss: (id: string) => void;
}

const ICONS: Record<string, string> = {
  success: '✓',
  info: '☏',
  warn: '!',
  error: '✕',
};

export function Toasts({ messages, onDismiss }: Props) {
  return (
    <div className="toasts">
      {messages.map(m => <ToastItem key={m.id} msg={m} onDismiss={onDismiss} />)}
    </div>
  );
}

function ToastItem({ msg, onDismiss }: { msg: ToastMessage; onDismiss: (id: string) => void }) {
  useEffect(() => {
    const t = setTimeout(() => onDismiss(msg.id), 3500);
    return () => clearTimeout(t);
  }, [msg.id, onDismiss]);

  return (
    <div className={`toast ${msg.kind || 'success'}`} onClick={() => onDismiss(msg.id)}>
      <div className="tic">{ICONS[msg.kind || 'success']}</div>
      <div>
        <b>{msg.title}</b>
        {msg.sub ? <span>{msg.sub}</span> : null}
      </div>
    </div>
  );
}
